// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-page {
    width: 90%;
    height:78vh;
    border-radius: 15px;
    overflow: auto;
    margin-bottom: 45px;
}
.container-page-list {
    width: 90%;
    height:73vh;
    position: relative;
    overflow: hidden;
}
.container-flash-border{
    background: rgba(0, 22, 29, 0.57);
    border-radius: 15px;
    height:100%;
}



button.btn-1-xl {

}

a.btn-1,
button.btn-1 {
    background: var(--blue);
    border: none;
    padding: 10px 20px;
    border-radius: 25px;
    color: black;
    font-size: 10px;
    font-weight: 400;
}

a.btn-1:hover,
button.btn-1:enabled:hover {
    background: var(--gray);
}

a.btn-1:focus,
button.btn-1:focus{
    box-shadow: none;
}

button.btn-2 {
    background: transparent;
    color: white;
    padding: 10px 20px;
    border-radius: 25px;
    font-size: 10px;
    font-weight: 400;
    border: 1px solid white;
}
button.btn-2:enabled:hover {
    background: var(--gray);
    border-color: white;
}

button.btn-2:focus{
    box-shadow: none;
}


/* Responsive styles */
@media (max-width: 768px) {
    .container-page-list,
    .container-page {
        border-radius: 8px;
    }
}
@media (max-width: 375px) {
    .container-page-list {
        height:65vh;
    }
    .container-page {
        height:75vh;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/pages.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,WAAW;AACf;;;;AAIA;;AAEA;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA,sBAAsB;AACtB;IACI;;QAEI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":[".container-page {\n    width: 90%;\n    height:78vh;\n    border-radius: 15px;\n    overflow: auto;\n    margin-bottom: 45px;\n}\n.container-page-list {\n    width: 90%;\n    height:73vh;\n    position: relative;\n    overflow: hidden;\n}\n.container-flash-border{\n    background: rgba(0, 22, 29, 0.57);\n    border-radius: 15px;\n    height:100%;\n}\n\n\n\nbutton.btn-1-xl {\n\n}\n\na.btn-1,\nbutton.btn-1 {\n    background: var(--blue);\n    border: none;\n    padding: 10px 20px;\n    border-radius: 25px;\n    color: black;\n    font-size: 10px;\n    font-weight: 400;\n}\n\na.btn-1:hover,\nbutton.btn-1:enabled:hover {\n    background: var(--gray);\n}\n\na.btn-1:focus,\nbutton.btn-1:focus{\n    box-shadow: none;\n}\n\nbutton.btn-2 {\n    background: transparent;\n    color: white;\n    padding: 10px 20px;\n    border-radius: 25px;\n    font-size: 10px;\n    font-weight: 400;\n    border: 1px solid white;\n}\nbutton.btn-2:enabled:hover {\n    background: var(--gray);\n    border-color: white;\n}\n\nbutton.btn-2:focus{\n    box-shadow: none;\n}\n\n\n/* Responsive styles */\n@media (max-width: 768px) {\n    .container-page-list,\n    .container-page {\n        border-radius: 8px;\n    }\n}\n@media (max-width: 375px) {\n    .container-page-list {\n        height:65vh;\n    }\n    .container-page {\n        height:75vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
